export default __webpack_public_path__ + "static/desktop-bg-right-mask-67913a38de5d1ced3959f1f9e3ca542e.png";